import React, { useCallback, useMemo } from 'react';
import { CnDialog, Field, Form, Select } from '@alife/cn-ui';
import $i18n from '@alife/panda-i18n';
const FormItem = Form.Item;
const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 20 },
};
export default function SelectPrint(props) {
    const { visible, setVisible, printerList, onOk = () => { } } = props;
    const field = Field.useField();
    const handleOk = useCallback(() => {
        field.validate((errors, values) => {
            if (errors) {
                return;
            }
            const { printName } = values;
            const printer = printerList?.find((prt) => prt.label === printName);
            onOk(printer);
            setVisible(false);
        });
    }, [field, onOk, printerList, setVisible]);
    const formateDataSource = useMemo(() => {
        return printerList?.map((item) => ({
            ...item,
            value: item.label,
        }));
    }, [printerList]);
    return (<CnDialog title={$i18n.get({ id: 'SelectPrinter', dm: '选择打印机' })} visible={visible} style={{ width: '400px' }} onOk={handleOk} onCancel={() => {
            setVisible && setVisible(false);
        }} onClose={() => {
            setVisible && setVisible(false);
        }}>
      <Form field={field}>
        <FormItem label={$i18n.get({ id: 'Printer', dm: '打印机' })} {...formItemLayout} required>
          <Select {...field.init('printName')} style={{ width: '100%' }} dataSource={formateDataSource}/>
        </FormItem>
      </Form>
    </CnDialog>);
}
